import { IOffersFragment } from 'generated/graphql-gateway';
import { IConfigOfferFragment } from 'generated/sanity-graphql';

export type PromoCodeRedeemSuccessParam = {
  configOffer: IConfigOfferFragment;
  engineOffer: IOffersFragment;
};

export interface ILoyaltyPromoCodeDrawerProps {
  isOpen: boolean;
  onDismiss: () => void;
  promoCode?: string;
  onPromoCodeRedeemSuccess?: (param: PromoCodeRedeemSuccessParam) => void;
  onAuthenticationRequired: (promoCode: string) => void;
}

export type IPromoCodeProps = Pick<ILoyaltyPromoCodeDrawerProps, 'onPromoCodeRedeemSuccess'>;

export enum PromoCodeErrorReason {
  redeemedCode = 'REDEEMED_CODE',
  expiredCode = 'EXPIRED_CODE',
  invalidCode = 'INVALID_CODE',
}

export class PromoCodeError extends Error {
  public message: PromoCodeErrorReason;

  constructor(message: PromoCodeErrorReason) {
    super();
    this.message = message;
  }
}
